import { render } from "./AdminHotels.vue?vue&type=template&id=d58d6e2c&scoped=true"
import script from "./AdminHotels.vue?vue&type=script&lang=js"
export * from "./AdminHotels.vue?vue&type=script&lang=js"

import "./AdminHotels.vue?vue&type=style&index=0&id=d58d6e2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58d6e2c"]])

export default __exports__